export const categories = { 
  "pt": [
    "Fotografia e Vídeo",
    "Animação musical / DJ", // antes: Animação Musical
    "Animação Infantil",
    "Celebrante / Conservatória",
    "Transportes, viagens, táxis",  // antes: Motorista
    // "Segurança",
    "Cabeleireiros, estética, spa", // antes: Make-up / Massagem
    "Wedding Planners / MC",  // antes: Wedding Planner
    "Aluguer de som/luzes",
    "Assistência a animais de estimação",
    "Entretenimento",
    "Carros clássicos",
    "Convites/gifts",
    "Decoração de igreja",
    "Protocolo de igreja",
    "Vestidos de noiva e convidadas",
    "Fato de noivos e convidados",
    "Welcome parties",
    "Alojamento",
    "Engomadoria"
  ],
  "en": [
    "Photography and Video",
    "Musical Animation / DJ",  // antes: Musical Animation
    "Children's Animation",
    "Celebrant / Conservatory",
    "Transportation, travel, taxis", // antes: Driver
    // "Security",
    "Hairdressers, beauty salons, spa",  // antes: Make-up / Massage
    "Wedding Planners / MC",  // antes: Wedding Planner
    "Sound/lighting rental",
    "Pet care",
    "Entertainment",
    "Classic cars",
    "Invitations/gifts",
    "Church decoration",
    "Church protocol",
    "Wedding and guest dresses",
    "Wedding attire for brides and grooms and guests",
    "Welcome parties",
    "Accommodation",
    "Steaming"
  ],
  "fr": [
    "Photographie et Vidéo",
    "Animation Musicale / DJ", // antes: Animation Musicale
    "Animation pour Enfants",
    "Célébrant / Conservatoire",
    "Transports, voyages, taxis",  // antes: Chauffeur
    // "Sécurité",
    "Coiffeurs, salons de beauté, spas", // antes: Maquillage / Massage
    "Wedding Planners / MC",  // antes: Wedding Planner
    "Location de matériel son et lumière",
    "Soins aux animaux de compagnie",
    "Divertissement",
    "Voitures classiques",
    "Invitations/cadeaux",
    "Décoration d'église",
    "Protocole de l'église",
    "Robes de mariée et robes d'invitées",
    "Tenues de mariage pour les mariés et les invités",
    "Welcome parties",
    "Hébergement",
    "Défroissage"
  ],
  "es": [
    "Fotografía y Video",
    "Animación Musical / DJ",  // antes: Animación Musical
    "Animación Infantil",
    "Celebrante / Conservatorio",
    "Transporte, viajes, taxis",  // antes: Conductor
    // "Seguridad",
    "Peluquerías, salones de belleza, spa",  // antes: Maquillaje / Masaje
    "Wedding Planners / MC",  // antes: Wedding Planner
    "Alquiler de sonido e iluminación",
    "Cuidado de mascotas",
    "Entretenimiento",
    "Coches clásicos",
    "Invitaciones/regalos",
    "Decoración de la iglesia",
    "Protocolo de la Iglesia",
    "Vestidos de novia y de invitadas",
    "Vestimenta nupcial para novios e invitados",
    "Welcome parties",
    "Alojamiento",
    "Planchado"
  ]
};

export const categoriesKeys = [
  "PHOTO_VIDEO",
  "MUSIC_ANIMATION",
  "KIDS_ANIMATION",
  "CELEBRANT",
  "DRIVER",
  // "SECURITY",
  "MAKE_UP",
  "WEDDING_PLANNER",
  "SOUND_LIGHTING_RENTAL",
  "PET_CARE",
  "ENTERTAINMENT",
  "CLASSIC_CARS",
  "INVITATIONS_GIFTS",
  "CHURCH_DECOR",
  "CHURCH_PROTOCOL",
  "BRIDE_DRESSES",
  "GROOM_DRESSES",
  "WELCOME_PARTIES",
  "ACCOMMODATION",
  "STEAMING"
];

export const getCategoriesByLanguage = (language) => {
  if (!categories[language]) {
    throw new Error("Idioma inválido!");
  }

  return categories[language].map((name, index) => ({
    _id: categoriesKeys[index],
    name
  })).sort((a, b) => a.name.localeCompare(b.name));
};

export const getSortedCategories = (categories) => {
  const sorted = [...categories].sort((a, b) =>
    a.localeCompare(b)
  );

  return sorted;
};

export const findCategoryIndex = (category) => {
  let res = -1, temp_index = -1;

  Object.keys(categories).forEach(function(key) {
    temp_index = categories[key].indexOf(category);

    if(res === -1 && temp_index >= 0) {
      res = temp_index;
    }
  });

  return res;
}